import { cn } from 'components/UI/cn'
import { PiMagnifyingGlass, PiXCircleFill } from 'react-icons/pi'

/** Shared DS2026 search input — controlled value + focus state so the caller owns filtering and the focus-ring styling. */
export function FilterSearchInput({
  value,
  onChange,
  isFocused,
  onFocus,
  onBlur,
  placeholder,
}: {
  value: string
  onChange: (value: string) => void
  isFocused: boolean
  onFocus: () => void
  onBlur: () => void
  placeholder: string
}) {
  const hasValue = value.length > 0
  return (
    <div
      className={cn(
        'relative flex items-center gap-1 rounded-[6px] border bg-white py-2 pl-2 pr-3',
        isFocused
          ? 'border-brand-active shadow-[0px_4px_8px_3px_rgba(6,81,47,0.1)]'
          : 'border-line'
      )}
    >
      <PiMagnifyingGlass
        className={cn(
          'h-5 w-5 flex-shrink-0',
          isFocused ? 'text-brand' : hasValue ? 'text-fg-muted' : 'text-fg'
        )}
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        aria-label={placeholder}
        className="flex-1 border-none bg-transparent text-sm text-fg outline-none placeholder-fg-muted"
      />
      {hasValue && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="flex-shrink-0 cursor-pointer border-none bg-transparent p-0"
        >
          <PiXCircleFill className="h-[13px] w-[13px] text-fg-muted" />
        </button>
      )}
    </div>
  )
}
